module.exports = __webpack_public_path__ + "img/bz.98068051.png";